import React from "react";

const RightArrow = () => {

    return (
      <React.Fragment>
        <div style={{position : 'absolute', right : 0, marginRight : 18, marginTop : -19}}>
            <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 8H19M19 8L12 1M19 8L12 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </div>
      </React.Fragment>
    )
}

export default RightArrow;



